import { useEffect } from 'react'
// key - the name of the key to respond to, compared against event.key
// action - the action to perform on key press
export default function useStopBackgroundScroll (modalTypeOpen?: string) {
  useEffect(() => {
    if (modalTypeOpen !== undefined) { // disable scrolling when modals are open
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'visible'
    }
  }, [modalTypeOpen])
}
